import { CourseLoaderConfig } from "./types";
import { initializeCourseLoader } from "./courseLoader";
import { setupProfileAccordionOnReady } from "./profileAccordion";

/**
 * Organization Detail Widget
 * Handles course loading and profile accordion/collapsible sections
 */

export const SaOrganizationDetailWidget = {
    init,
};

/**
 * Initializes the Organization Detail widget
 * Called when the widget is loaded in the page
 */
async function init(): Promise<void> {
    // Get organization details from the DOM
    const $organizationLanding = $("#organizationLanding");

    if (!$organizationLanding.length) {
        return;
    }

    const organizationId = $organizationLanding.data("id");
    const courseLandingPage = $organizationLanding.data("courselandingpage");

    // Initialize course loader if we have an organization ID
    if (organizationId) {
        const courseLoaderConfig: CourseLoaderConfig = {
            organizationId,
            courseLandingPage,
            organizationLogoCellId: "organizationLanding",
            organizationLogoDataAttribute: "organizationdefaultlogo",
        };
        await initializeCourseLoader(courseLoaderConfig);
    }

    // Initialize profile accordion sections
    setupProfileAccordionOnReady();
}

if (!SaNavigationUtils.NodeEnv.isTest()) {
    $(init);
}
